import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckPrimary = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#036fe2", fillRule: "evenodd", d: "M6.596 11.906 3.469 8.779 2.404 9.836l4.192 4.193 9-9-1.057-1.058z" }));
const ForwardRef = forwardRef(SvgIconCheckPrimary);
export default ForwardRef;
